import { API } from "@/lib/api";
import { toast } from "sonner";

export async function downloadFile(path, filename) {
  const token = localStorage.getItem("matiqs_token");
  try {
    const res = await fetch(`${API}${path}`, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) throw new Error();
    const blob = await res.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    a.click();
    URL.revokeObjectURL(a.href);
  } catch {
    toast.error("Could not download the file");
  }
}
